import { baseAxios } from "config";

const exportOnboardingLog = async (params = {}) => {
  const { startDate, endDate, format = "csv" } = params;

  const queryParams = new URLSearchParams();

  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  if (format) queryParams.append("format", format);

  const response = await baseAxios.get(
    `/applicants/onboarding-log/export?${queryParams.toString()}`,
    {
      responseType: "blob",
    }
  );

  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `onboarding_log_${new Date().toISOString().split("T")[0]}.${format}`
  );
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return response.data;
};

export default exportOnboardingLog;
